export const degrees = [
  // { value: null, label: "Select Degree" },
  { value: "Computer Studies", label: "Computer Studies" },
  { value: "Engineering", label: "Engineering" },
  { value: "Accounting and Finance", label: "Accounting and Finance" },
  { value: "Business and Management", label: "Business and Management" },
  { value: "Humanities", label: "Humanities" },
  { value: "Arts & Design", label: "Arts & Design" },
  { value: "Law", label: "Law" },
  { value: "Media Studies", label: "Media Studies" },
  { value: "Others", label: "Others" }
];
